import { ProcessDeUtil } from '../../../../domain/process-de-util';
import {PerformerEntity} from "../../entities/performer.entity";
export enum ReportingRank {
    DirectSuperior = 'DirectSuperior',
    HigherSuperior = 'HigherSuperior'
}
export class ReportingLineDataEntity extends PerformerEntity {
  constructor(id?: string, name?: string, type?: string) {
    super(id,name,type);
  }
  reportingLineDefId: string;
  reportingLineDefName: string;
  refOrgId: string;
  refOrgName: string;
  refUserId: string;
  refEmployeeId: string;
  dimension: string;
  condition: string;
  reportingReferObject: string;
}

